import InfiniteLoader from './InfiniteLoader';

export default InfiniteLoader;
export { InfiniteLoader };


//////////////////
// WEBPACK FOOTER
// ./~/react-virtualized/dist/es/InfiniteLoader/index.js
// module id = 980
// module chunks = 4